import _ from 'lodash';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useWorkshiftAPI } from '../../apis/workshift-api';
import { Feature, useFeature } from '../../hooks/use-feature';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function useWelcomeModal() {
  const { spot, user, menuInfo } = useStorage();
  const { t } = useTranslation();
  const storage = useStorage();
  const { analyticsPageView } = useAnalytics();
  const { isFeatureEnabled } = useFeature();
  const { swal } = useSwal({ storage });
  const { loadCurrentWorkshiftFromRemote } = useWorkshiftAPI();

  const shouldShowRef = useRef(false);

  function didOpen() {
    analyticsPageView('Welcome');
  }

  async function prepare() {
    try {
      const response = await loadCurrentWorkshiftFromRemote();
      shouldShowRef.current = !_.isEmpty(response.data);
    } catch (error) {
      shouldShowRef.current = false;
    }
  }

  async function show() {
    if (!shouldShowRef.current) return null;

    const result = await swal.fire({
      title: getTitle(),
      // title: <WelcomeModalTitle spot={spot} user={user} menuInfo={menuInfo} />,
      icon: 'success',
      text: getDescription(),
      showCloseButton: true,
      showConfirmButton: false,
      showDenyButton: true,
      denyButtonText: t('ok'),
      didOpen,
    });

    return result;
  }

  function getTitle() {
    if (user != null) {
      return user.name;
    }

    if (spot == null) {
      return menuInfo.name;
    }

    return spot.name;
  }

  function getDescription() {
    if (isFeatureEnabled(Feature.SELF_ORDERING)) {
      return t('welcome-modal.description.self_ordering');
    }

    return t('welcome-modal.description');
  }

  return {
    prepareWelcomeModal: prepare,
    showWelcomeModal: show,
  };
}

export { useWelcomeModal };
